// kakao map document
// https://apis.map.kakao.com/web/documentation

// declare global {
//     interface Window {
//         kakao: any;
//     }
// }

declare var kakao: any;

//////////////////////////////////

export namespace KakaoMap {

    export function getKakao(): Map {
        return kakao;
    }

    export declare type Map = any & {
        setBounds(bounds: LatLngBounds): unknown;
        setLevel(level: any): unknown;
        panTo(latLng: LatLng): unknown;
    };

    export declare type MapOptions = {
        // center LatLng: 중심 좌표(필수)
        center: LatLng;
        // level Number: 확대 수준(기본값: 3)
        level: number;
        // mapTypeId MapTypeId: 지도 종류(기본값: 일반 지도)
        // draggable Boolean: 마우스 드래그, 휠, 모바일 터치를 이용한 시점 변경(이동, 확대, 축소) 가능 여부
        // scrollwheel Boolean: 마우스 휠, 모바일 터치를 이용한 확대 및 축소 가능 여부
        // disableDoubleClick Boolean: 더블클릭 이벤트 및 더블클릭 확대 가능 여부
        // disableDoubleClickZoom Boolean: 더블클릭 확대 가능 여부
        // projectionId String: 투영법 지정(기본값: kakao.maps.ProjectionId.WCONG)
        // tileAnimation Boolean: 지도 타일 애니메이션 설정 여부(기본값: true)
        // keyboardShortcuts Boolean | Object : 키보드의 방향키와 +, – 키로 지도 이동, 확대, 축소 가능 여부(기본값: false)
        // speed Number: 지도 이동 속도
    };

    export declare type LatLng = {

        // 위도를 반환한다.
        getLat(): number;

        // 경도를 반환한다.
        getLng(): number;

        // 객체가 가지고 있는 좌표와 같은 좌표를 가지고 있는 객체인지 비교한다.
        equals(latlng: LatLng): boolean;

        // 객체가 가지고 있는 좌표를 Wcongnamul 좌표로 반환한다.
        toCoords(): any;

        // 객체가 가지고 있는 좌표를 문자열로 반환한다.
        // "(37, 127)"
        toString(): string;
    };
    export declare type LatLngBounds = {
        // 영역의 남서쪽 좌표를 반환한다.
        getSouthWest(): LatLng;
        // 영역의 북동쪽 좌표를 반환한다.
        getNorthEast(): LatLng;
        // 영역 정보가 비어있는지 확인한다.
        isEmpty(): boolean;
        // 인수로 주어진 좌표를 포함하도록 영역 정보를 확장한다.
        extend(latLng: LatLng): void;
        // 영역 객체가 인수로 주어진 좌표를 포함하는지 확인한다.
        contain(latLng: LatLng): boolean;
        // "((36, 127), (37, 128))"
        toString(): string;
    };
    export declare type RectangleOptions = {
        map?: Map;
        // 사각형의 영역
        bounds?: LatLngBounds;
        // String: #xxxxxx 형태의 채움 색(기본값: ‘#F10000’)
        fillColor?: string;
        // Number: 채움 불투명도(0 - 1)(기본값: 0)
        fillOpacity?: number;
        // Number: 픽셀 단위의 선 두께(기본값: 3)
        strokeWeight?: number;
        // String: #xxxxxx 형태의 선 색(기본값: ‘#F10000’)
        strokeColor?: string;
        // Number: 선 불투명도(0 - 1)(기본값: 0.6)
        strokeOpacity?: number;
        // String: 선 스타일(기본값: ‘solid’)
        strokeStyle?: 'solid' | 'shortdash' | 'shortdot' | 'shortdashdot' | 'shortdashdotdot' | 'dot'
        | 'dash' | 'dashdot' | 'longdash' | 'longdashdot' | 'longdashdotdot';
        // Number: 사각형의 z - index 속성 값
        zIndex?: number;
    }
    export declare type Rectangle = {
        setBounds(rectangleBounds: LatLngBounds): unknown;
        setMap(map: Map | null): void;
    };

    export declare type Polyline = {
        setMap(map: any): unknown;
        getPath(): LatLng[]
    };

    export declare type CustomOverlayOptions = {
        // Map | Roadview : 커스텀 오버레이가 올라갈 지도 또는 로드뷰
        map?: Map;
        //  true 로 설정하면 컨텐츠 영역을 클릭했을 경우 지도 이벤트를 막아준다.
        clickable?: boolean;
        //  Node | String : 엘리먼트 또는 HTML 문자열 형태의 내용
        content?: any;
        // LatLng | Viewpoint : 커스텀 오버레이의 좌표 또는 로드뷰에서의 시점
        position?: LatLng;
        // 컨텐츠의 x축 위치. 0_1 사이의 값을 가진다.기본값은 0.5
        xAnchor?: number;
        //컨텐츠의 y축 위치. 0_1 사이의 값을 가진다.기본값은 0.5
        yAnchor?: number;
        // 커스텀 오버레이의 z - index
        zIndex?: number;
    }

    export declare type CustomOverlay = any & {
        setContent(content: any): void;
        // 커스텀 오버레이의 z - index를 설정한다.
        setZIndex(zIndex: number): void
        // 커스텀 오버레이의 z - index를 반환한다.
        getZIndex(): number;
    };

    export declare type MarkerOptions = {
        map?: Map;
        position?: LatLng;
        image?: any;
        yAnchor?: any;
        xAnchor?: any;
    }
    export declare type Marker = {
    };

    // LatLng에서 lat는 y축, lng는 x축에 해당하며, 일반적으로 (lat, lng)로 표현됩니다.
    export function newLatLng(lat: any, lng: any): LatLng {
        return new kakao.maps.LatLng(lat, lng);
    }

    /**
     * WGS84 좌표계에서 사각영역 정보를 표현하는 객체를 생성한다
     * 
     * @param sw LatLng : 사각 영역에서 남서쪽 좌표
     * @param ne LatLng : 사각 영역에서 북동쪽 좌표
     * @returns 
     */
    export function newLatLngBounds(sw?: LatLng, ne?: LatLng): LatLngBounds {
        return new kakao.maps.LatLngBounds(sw, ne); // 인자를 주지 않으면 빈 영역을 생성한다.
    }

    /**
     * 사각형를 생성한다.
     * @param options 
     * @returns 
     */
    export function newRectangle(options: RectangleOptions & any): Rectangle {
        return new kakao.maps.Rectangle(options);
    }

    export function newCustomOverlay(options: CustomOverlayOptions): CustomOverlay {
        return new kakao.maps.CustomOverlay(options);
    }

    export function newPolyline(options: any): Polyline {
        return new kakao.maps.Polyline(options);
    }

    export function newMarker(options: MarkerOptions): Marker {
        return new kakao.maps.Marker(options);
    }

    export namespace maps {

        export function setBounds(map: KakaoMap.Map, latLngs: KakaoMap.LatLng[]) {
            if (!map) { return; }
            if (!latLngs || latLngs.length < 1) { return; }
            let bounds = KakaoMap.newLatLngBounds();
            latLngs.forEach(latLng => bounds.extend(latLng));
            map.setBounds(bounds);
        }

        // var mapTypeControl = new kakao.maps.MapTypeControl();
        // mapRef.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT);

        export function addZoomCtrl(map: Map) {
            var zoomControl = new kakao.maps.ZoomControl();
            map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);
        }
        export function addWhiteTileSet(map: any) {
            // Tileset을 생성하고 지도 오버레이로 추가합니다
            kakao.maps.Tileset.add('TILE_NUMBER',
                new kakao.maps.Tileset({
                    width: 256,
                    height: 256,
                    getTile: function (x: any, y: any, z: any) {
                        var div = document.createElement('div');
                        div.style.backgroundColor = "#fff";
                        div.style.opacity = "0.4";
                        return div;
                    }
                }));

            // 지도 위에 TILE_NUMBER 오버레이 레이어를 추가합니다
            map.addOverlayMapTypeId(kakao.maps.MapTypeId.TILE_NUMBER);
        }
    }

    export namespace tools {

        export function calcBoundsWithOffset(latLng: LatLng, distance: number): LatLngBounds {
            return KakaoMap.newLatLngBounds(
                calcLatLngToSouthWest(latLng, distance),
                calcLatLngToNorthEast(latLng, distance)
            )
        }

        export function calcLatLngToNorth(latLng: LatLng, distance: number) {
            return getOffsetLatLng(latLng, distance, 0);
        }

        export function calcLatLngToSouth(latLng: LatLng, distance: number) {
            return getOffsetLatLng(latLng, distance, Math.PI);
        }

        export function calcLatLngToEast(latLng: LatLng, distance: number) {
            return getOffsetLatLng(latLng, distance, Math.PI / 2);
        }

        export function calcLatLngToWest(latLng: LatLng, distance: number) {
            return getOffsetLatLng(latLng, distance, 3 * Math.PI / 2);
        }

        export function calcLatLngToSouthWest(latLng: LatLng, distance: number) {
            return calcLatLngToWest(calcLatLngToSouth(latLng, distance), distance);
        }

        export function calcLatLngToNorthEast(latLng: LatLng, distance: number) {
            return calcLatLngToEast(calcLatLngToNorth(latLng, distance), distance);
        }

        function getOffsetLatLng(latLng: LatLng, distance: number, bearing: number) {
            distance = distance / 1000;
            var earthRadius = 6371; // 지구 반지름 (단위: km)
            var dLat = distance * Math.cos(bearing) / earthRadius * (180 / Math.PI);
            var dLng = distance * Math.sin(bearing) / (earthRadius * Math.cos(latLng.getLat() * Math.PI / 180)) * (180 / Math.PI);

            var newLat = latLng.getLat() + dLat;
            var newLng = latLng.getLng() + dLng;

            return newLatLng(newLat, newLng);
        }
    }

}

export namespace NpMapCuso {

    export function newLabelTextBox(labelText: string, showAlways?: boolean) {
        const content = document.createElement('div');
        content.classList.add("label-text-box");
        if (showAlways) {
            content.classList.add("show");
        }
        content.innerHTML = `<div class="label-text">${labelText}</div>`;
        return content;
    }

    export function createElement(innerHTML: string) {
        // 템플릿 엘리먼트를 생성합니다.
        var template = document.createElement('template');
        // 템플릿의 innerHTML 속성에 원하는 HTML 문자열을 넣습니다.
        template.innerHTML = innerHTML;
        // 템플릿의 첫 번째 자식 요소를 클론하여 문서의 원하는 위치에 삽입합니다.
        return template.content.firstElementChild?.cloneNode(true);
    }

}


// // 마커 이미지 URL
// var markerImageUrl = 'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png';
// // 마커 이미지 크기
// var markerImageSize = new kakao.maps.Size(24, 35);
// // 마커 이미지 옵션
// var markerImageOptions = {
//   offset: new kakao.maps.Point(12, 35) // 마커의 중심좌표
// };
// // 마커 이미지 생성
// var markerImage = new kakao.maps.MarkerImage(markerImageUrl, markerImageSize, markerImageOptions);

// let marker = KakaoMap.newMarker({
//   map: this.kakaoMap1.mapRef,
//   position: position,
//   image: markerImage
// });

